<template lang="pug">
.column-flex
  Maintenance
  .cloud.login-wrapper
    .login
      .login__content
        .login__header
          cloud-icon.icon(ref="iconDashboard" name="LogoVisionFace")
        h1.login__title {{ $t(forgotPassword ? "login.recover.title" : "login.title") }}
        .login__form
          .forgotMessage(v-if="forgotPassword")
            p.login__message {{ $t('login.recover.message') }}
            p.login__message {{ $t('login.recover.noEmail') }}
          .generalError(v-if="serverMessage !== ''")
            p.login__message.alert(:class="serverClass" v-html="serverMessage")
          form(v-if="forgotPassword"
            :action="apiUrl"
            method="post"
            id="recover"
            @submit.prevent="recoverPassword")
            .emailSection.login-form-group
              label.label(for="confirmEmail") {{ $t('login.email') }}
              input.input(
                @blur="validateEmail(true)"
                type="text"
                id="confirmEmail"
                v-model="email"
                name="confirmEmail"
                ref="confirmEmail"
                autocomplete="confirmEmail"
                required
                :class="{error: emailMessage && emailMessage != 'valide'}"
              )
              .input-error(v-if="emailMessage && emailMessage != 'valide'")
                p.login__message.error {{ emailMessage }}
            .login-form-actions
              input.log(type="submit" :value="$t('login.recover.email')")
            .login-form-actions
              button.cancelButton(type="button" @click="forgotPassword = false") {{ $t('cancel') }}
          form(
            v-if="!forgotPassword"
            :action="apiUrl"
            method="post"
            id="form"
            @submit.prevent="checkLogin")
            .emailSection.login-form-group
              label.label(for="email") {{ $t('login.email_username') }}
              input.input(
                @blur="validateEmail"
                type="text"
                id="email"
                v-model="email"
                name="email"
                ref="email"
                autocomplete="email"
                required
                :class="{error: emailMessage && emailMessage != 'valide'}"
              )
              .input-error(v-if="emailMessage && emailMessage != 'valide'")
                p.login__message.error {{ emailMessage }}
            .passwordSection.login-form-group
              label.label(for="password") {{ $t('login.password') }}
              input.input(
                @blur="validatePassword"
                type="password"
                id="password"
                v-model="password"
                name="password"
                ref="password"
                autocomplete="current-password"
                required
                :class="{error: passwordMessage && passwordMessage != 'valide'}"
              )
              .input-error(v-if="passwordMessage && passwordMessage != 'valide'")
                p.login__message.error {{ passwordMessage }}
            .login-form-actions
              template(v-if="!isLoading")
                input.log(type="submit" :value="$t('login.title')")
                p.login__message(@click="forgotPassword = !forgotPassword" :style="{cursor: 'pointer'}") {{ $t('login.forgotPW') }}
              .log--spinner(v-else)
                cloud-icon.icon.icon__spinner(name="spinner")
  .cloud.login-footer
    component(:is="{template: $t('infoPolicy')}")
    .text.copyright © Copyright {{ new Date().getFullYear() }} | Jyga Technologies inc.<br>{{ $t('allRights')}}
</template>

<script>
import axios from "axios";
import RequestHelper from "@/functions/RequestHelper";
import Axios from "axios";
import Maintenance from "@/components/maintenance.vue";
import qs from "qs";
import store from "@/store";

export default {
  name: "login",
  components: {
    Maintenance
  },
  data() {
    return {
      email: null,
      password: null,
      emailMessage: null,
      passwordMessage: null,
      serverMessage: "",
      serverClass: "",
      loginError: false,
      apiUrl: process.env.VUE_APP_API_URL,
      forgotPassword: false,
      isLoading: false
    };
  },
  methods: {
    themeSplit() {
      let body = document.body;
      body.classList.add("dark-body");
      let cloudLogin = document.getElementsByClassName("cloud")[0];
      let cloudFooter = document.getElementsByClassName("cloud")[1];
      let cloudModal = document.getElementsByClassName("cloud")[2];
      if (
        window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches
      ) {
        body.classList.add("dark-body");
        if (cloudLogin) cloudLogin.classList.add("dark");
        if (cloudFooter) cloudFooter.classList.add("dark");
        if (cloudModal) cloudModal.classList.add("dark");
      } else {
        body.classList.remove("dark-body");
        if (cloudLogin) cloudLogin.classList.remove("dark");
        if (cloudFooter) cloudFooter.classList.remove("dark");
        if (cloudModal) cloudModal.classList.remove("dark");
      }
    },
    validateEmail(onlyEmail = false) {
      this.serverMessage = "";
      const emailClass = this.forgotPassword ? "confirmEmail" : "email";
      const emailRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const usernameRegex = /^(?!.*\.\.)(?!.*\.$)[^\W][\w.]{5,29}$/;
      if (this.email === "" || !this.email) {
        document.getElementById(emailClass).classList.add("error");
        this.emailMessage = this.$t("login.messages.fieldRequired");
      } else if (
        (typeof onlyEmail === "boolean" &&
          onlyEmail &&
          !emailRegex.test(this.email)) ||
        ((typeof onlyEmail !== "boolean" || !onlyEmail) &&
          !emailRegex.test(this.email) &&
          !usernameRegex.test(this.email))
      ) {
        document.getElementById(emailClass).classList.add("error");
        this.emailMessage = this.$t("settings.invalidEmail");
      } else {
        document.getElementById(emailClass).classList.remove("error");
        this.emailMessage = "valide";
      }
    },
    validatePassword() {
      this.serverMessage = "";
      if (this.password === "" || !this.password) {
        document.getElementById("password").classList.add("error");
        this.passwordMessage = this.$t("login.messages.fieldRequired");
      } else if (this.password.length >= 32) {
        document.getElementById("password").classList.add("error");
        this.passwordMessage = this.$t("login.messages.longPW");
      } else {
        document.getElementById("password").classList.remove("error");
        this.passwordMessage = "valide";
      }
    },
    async checkLogin() {
      if (this.email && this.password) {
        this.isLoading = true;
        axios
          .post(
            `${process.env.VUE_APP_API_URL}auth`,
            {},
            {
              auth: {
                username: this.email,
                password: this.password
              }
            }
          )
          .then(async response => {
            return await this.handleSuccessLogin(response);
          })
          .catch(e => {
            return this.handleErrorLogin(e.response);
          });
        return true;
      } else {
        this.handleErrorCheckLogin();
      }
    },
    async handleSuccessLogin(response) {
      if (response.data.token) {
        try {
          const response = await axios.post(
            `${process.env.VUE_APP_KEYCLOAK_URL}realms/jyga/protocol/openid-connect/token`,
            qs.stringify({
              client_id: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
              client_secret: process.env.VUE_APP_KEYCLOAK_CLIENT_SECRET,
              grant_type: "password",
              username: this.email,
              password: this.password
            }),
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              }
            }
          );
          store.commit("general/setTokenKeycloak", response.data.access_token);
          store.commit("general/setRefreshToken", response.data.refresh_token);
        } catch (error) {
          console.error("Keycloak Unauthorized:", error);
          store.commit("clearToken");
          store.commit("clearRefreshToken");
          this.loginError = true;
          this.isLoading = false;
          this.serverClass = "error";
          this.serverMessage = this.$t("login.messages.probConnect");
        }

        await this.handleLoginWithToken(response.data.token);
      } else {
        this.loginError = true;
        this.isLoading = false;
        this.serverClass = "error";
        this.serverMessage = this.$t("login.messages.probConnect");
      }

      return response;
    },
    async handleLoginWithToken(token) {
      this.$store.commit("general/setToken", token);
      this.$store.commit("setPassword", this.password);
      await this.$user.loadFromApi();
      if (this.$user.isTech() || this.$user.isStaff()) {
        await this.$sites.loadStaffFromApi();
      } else if (this.$user.role !== "integrator") {
        await RequestHelper.get("members").then(data => {
          this.$store.commit("general/setMemberships", data.data);
        });
        await this.$sites.loadFromApi();
      }
      this.isLoading = false;
      if (
        this.$user.role !== "integrator" &&
        this.$user.hasAnyAccess() &&
        this.$sites.tenants.length
      ) {
        this.handleLoginRoute();
      } else {
        this.loginError = true;
        this.serverClass = "error";
        this.serverMessage = this.$t("login.messages.noAccess");
        this.$store.commit("setAllDefault");
      }
    },
    handleLoginRoute() {
      if (!this.$user.agreed_terms_policy || this.$user.never_login) {
        this.$router.push({ name: "agreements" });
      } else if (
        this.$user.role === "integrator" ||
        this.$sites.sites.some(s => s.hasFeeding() || s.hasZootech())
      ) {
        this.$router.push({ name: "root" });
      } else {
        this.$router.push({ name: "silos" });
      }
    },
    handleErrorLogin(response) {
      this.isLoading = false;
      if (response && response.status >= 400 && response.status < 500) {
        this.loginError = true;
        this.serverClass = "error";
        if (
          response.data &&
          response.data.message &&
          ["user_notfound", "authentication_failed"].includes(
            response.data.message
          )
        ) {
          this.serverMessage = this.$t(
            `login.messages.${
              response.data.message === "user_notfound"
                ? "userNotFound"
                : "wrongPassword"
            }`
          );
        } else {
          this.serverMessage = this.$t("login.messages.unauthorized");
        }
      } else {
        this.loginError = true;
        this.serverClass = "error";
        this.serverMessage = this.$t("login.messages.serverError");
      }
      return false;
    },
    handleErrorCheckLogin() {
      if (!this.email && !this.password) {
        this.loginError = true;
        this.serverClass = "error";
        this.serverMessage = this.$t("login.messages.emailPassRequired");
      } else {
        if (!this.email) {
          this.loginError = true;
          this.serverClass = "error";
          this.serverMessage = this.$t("login.messages.emailRequired");
        }

        if (!this.password) {
          this.loginError = true;
          this.serverClass = "error";
          this.serverMessage = this.$t("login.messages.passRequired");
        }
      }
    },
    async recoverPassword() {
      if (this.email) {
        let error = null;
        await Axios.post(`${process.env.VUE_APP_API_URL}user/recover`, {
          email: this.email
        }).catch(e => (error = e.response));
        if (error) {
          if (error.status >= 400 && error.status < 500) {
            this.loginError = true;
            this.serverClass = "error";
            this.serverMessage = this.$t("login.recover.notFound");
          } else {
            this.loginError = true;
            this.serverClass = "error";
            this.serverMessage = this.$t("login.messages.serverError");
          }
          return false;
        } else {
          this.loginError = true;
          this.serverClass = "success";
          this.serverMessage = this.$t("login.recover.link");
        }
        return true;
      } else {
        // email not provided
        this.loginError = true;
        this.serverClass = "error";
        this.serverMessage = this.$t("login.messages.emailRequired");
      }
    }
  },
  mounted() {
    this.themeSplit();
    if (this.$route.params.message && this.$route.params.messageClass) {
      this.loginError = false;
      this.serverMessage = this.$route.params.message;
      this.serverClass = this.$route.params.messageClass;
      if (this.serverClass === "valide") {
        this.serverClass = "success";
      }
    }
  },
  created() {
    this.themeSplit();
  }
};
</script>

<style lang="stylus" scoped>
@import "../assets/css/mixins.styl";

.column-flex
  display flex
  flex-flow column
  height 100%

.login
  align-items center
  background-color white
  box-shadow 0 1px 1px rgba(23, 43, 77, 0.2),
  0 0 0.5px 0 rgba(23, 43, 77, 0.25)
  display flex
  justify-content center
  height 100%
  width 100%
  @media screen and (--min-large-mobile)
    border-radius var(--global-radius)
    height auto
    width 330px

  &-wrapper
    align-items center
    background-color var(--blue)
    display flex
    justify-content center
    width 100vw
    flex-grow 1

  &__content
    width 100%

  &__header
    display flex
    justify-content flex-end
    margin var(--vertical-spacing) 0 0
    padding 0 var(--horizontal-spacing)

  &__host
    align-self center
    margin-left auto

  &__title
    color var(--black)
    flex 0 0 100%
    font-size 32px
    font-weight var(--font-black)
    line-height 32px
    margin 0
    margin-bottom 10px
    padding 0 var(--horizontal-spacing)

  &__message
    font-size 15px
    margin 0 auto
    padding 0 var(--horizontal-spacing)

  &__form
    margin 0 0 calc(var(--vertical-spacing) * 1.5) 0

    form
      margin-top 35px

      & .login-form-group
        margin-top 20px
      @media screen and (--min-large-mobile)
        margin-top 20px

  &-forgot
    margin 0
    text-align center

    a
      color var(--black-clay)
      text-decoration none

      &:hover
        text-decoration underline

.login__form .generalError
  margin 0 20px

  .login__message
    width 100%

.login-form-group
  display flex
  flex-direction column
  justify-content flex-start
  margin-top calc(var(--vertical-spacing) / 2)
  padding 0 var(--horizontal-spacing)
  position relative

  &_small, &_medium, &_wide
    flex 0 0 100%
  @media (--medium-up)
    &_small
      flex 0 1 140px

    &_medium
      flex 0 1 280px

    &_wide
      flex 1 1 100%

.login-form-actions
  display flex
  flex-direction column
  margin var(--vertical-spacing) 0
  padding 0 var(--horizontal-spacing)
  width 100%

  & > *
    &:first-child
      margin-left 0

  .cancelButton
    font-size 16px
    margin -10px auto
    padding 10px 0
    width 100%
    background-color transparent
    color var(--blue)

    &:hover, &:focus, &:active
      box-shadow none !important
  @media (--medium-up)
    margin calc(var(--vertical-spacing) / 2) 0
    margin-top calc(var(--vertical-spacing) / 2 + 4px)
    & > *
      &:first-child
        margin-left auto

    &_inline
      align-items flex-start
      flex-direction column
      justify-content center
      width auto

    &_inline > *
      &:first-child
        margin-left 0

.input
  -moz-appearance textfield
  appearance none
  background-color white
  border 1px solid rgba(9, 30, 66, 0.13)
  border-radius calc(var(--global-radius) * 1.5)
  color var(--black)
  font-size 16px
  font-weight var(--font-regular)
  height 54px
  line-height var(--vertical-spacing)
  margin-bottom 10px
  padding 0 .75rem
  transition-property background-color
  @mixin animate

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button
    -webkit-appearance none
    margin 0

  &:focus
    outline 0

  &:focus:not(&_invalid)
    border 2px solid var(--blue)
    box-shadow 0 1px 0 0 rgba(22, 29, 37, 0.05)

  &:disabled
    user-select none

  &_disabled
    background-color var(--athens-gray)
    border-color rgba(9, 30, 66, 0.13)
    color rgba(9, 30, 66, 0.5)

  &_invalid
    background-color var(--linen)
    border-color var(--red)

  &-error
    .error
      margin 0
  @media (--medium-up)
    font-size 16px
    height 36px

.label + .input
  margin-top 6px
  @media (--medium-up)
    margin-top 4px

.label
  align-items center
  color var(--black-clay)
  display flex
  font-size 16px
  font-weight var(--font-bold)
  line-height var(--vertical-spacing)
  @include animate

  &[for]:not(&_disabled):hover
    cursor pointer

  &_disabled
    color rgba(9, 30, 66, 0.5)

  &_invalid
    color var(--red)

.log
  align-items center
  -webkit-appearance none
  border none
  border-radius var(--global-radius)
  box-sizing border-box
  cursor pointer
  display inline-flex
  font-size 16px
  font-weight 700
  justify-content center
  margin 10px 5px
  padding 10px 8px
  position relative
  -webkit-tap-highlight-color rgba(0, 0, 0, 0)
  text-align center
  text-decoration none
  user-select none
  vertical-align middle
  transition-duration 0.25s
  transition-timing-function cubic-bezier(0.4, 0, 0.2, 1)
  text-overflow ellipsis
  white-space initial
  width 100%
  background-color var(--blue)
  color #fff

  &:focus, &:hover, &:active
    background-color rgba(0, 82, 204, 0.9)
    outline 0

  &--spinner
    padding 8px
    background-color var(--blue)
    border-radius 100%
    width 40px
    margin 10px auto 0

.login-footer
  display flex
  flex-flow column wrap
  justify-content space-between
  padding 10px 20px
  height 10vh
  @media screen and (--min-large-mobile)
    flex-flow row wrap
    height auto

  .copyright, a
    font-size 10px
    line-height 1.2
    text-align center
    color var(--black)

  .copyright >>> a
    text-decoration underline
    display inline-block
    margin-right 10px

    &:link, &:visited, &:hover, &:focus, &:active
      color var(--black)

.forgotMessage p
  margin-bottom 10px

.dark
  .login-form-actions .cancelButton
    color var(--athens-gray)

  &.login-wrapper, &.login-footer, &.modal .modal-container
    background-color var(--dark-nav)

    .copyright, a, .copyright >>> a
      color #aaa

  .login
    background-color var(--dark-SB)

    .label
      color var(--athens-gray)

  .login__title, .login-forgot > *
    color var(--athens-gray)

  .icon
    fill var(--athens-gray)

.icon
  fill var(--blue)
  width 30px

  &__spinner
    stroke var(--athens-gray)
</style>
